(function () {
  function fsGetCredit(totalPence, items) {
    if (!items || !items.length) return 0;
    var allGiftCards = items.every(function (i) { return i.gift_card; });
    if (allGiftCards) return 0;
    if (totalPence >= 7200) return 15;
    if (totalPence >= 4800) return 12;
    if (totalPence >= 2400) return 8;
    return 0;
  }

  function fsRenderCredit(credit) {
    document.querySelectorAll('[data-fs-store-credit-earn]').forEach(function (el) {
      var span = el.querySelector('.fs-store-credit-earn__msg');
      if (credit > 0) {
        if (span) span.textContent = 'This order earns you £' + credit + ' store credit for your next order.';
        el.style.display = 'flex';
      } else {
        el.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.subscribe && window.theme && window.theme.PUB_SUB_EVENTS) {
      window.subscribe(window.theme.PUB_SUB_EVENTS.cartUpdate, function (payload) {
        var cart = payload && payload.cartData;
        if (!cart) return;
        fsRenderCredit(fsGetCredit(cart.total_price, cart.items));
      });
    }
  });
})();
